import jsStyleToString from "../utils/jsStyleToString.mjs"

export const styles_button = jsStyleToString({
  color: 'var(--color-ai-text)',
  fontFamily: 'Sans-Serif',
  fontSize:'12px',
  textTransform: 'uppercase'
})